// extracted by mini-css-extract-plugin
export var closeButton = "_ix-1";
export var closeX = "_ix-3";
export var container = "_ix-0";
export var image = "_ix-2";